module.exports = __webpack_public_path__ + "static/img/logo2x.84abf67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2x.png
// module id = ubrd
// module chunks = 1